<template>
	<router-view />
</template>

<style lang="scss">
#app {
	@apply flex;
	@apply justify-center;

	font-family: Roboto, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	@apply text-dark;
}
</style>
